import { render, staticRenderFns } from "./ETFAnalyzer.vue?vue&type=template&id=8b451e38&scoped=true&"
import script from "./ETFAnalyzer.vue?vue&type=script&lang=js&"
export * from "./ETFAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b451e38",
  null
  
)

export default component.exports